import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import './Steps.scss';
import { useMediaQuery } from "@mui/material";
import profileverification from "../../../assets/images/svg/newDesign/profileverification.svg"
import { Link } from "react-router-dom/cjs/react-router-dom";
import Cookies from "js-cookie";


const StepFour = (moveToProfileVerification, setConsultation, setprofileVerification) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const [currentStepFour, setCurrentStepFour] = useState(0);

    const handleRedirectToLanding = () => {
        Cookies.remove('token');
        window.location.href = "/signup-number"
    }

    return (
        <div className="stepFrour">
            <Container>
                <Row>
                    <Col lg={6} className="mx-auto">
                        <div className="boxfour text-center">
                            <img src={profileverification} width={330} className="img-fluid mx-auto"></img>
                            <h3>Your profile has been submitted successfully!</h3>
                            <p>Our team will verify your information to ensure authenticity. Thank you for your patience during this process.</p>
                            <button onClick={() => handleRedirectToLanding()} className="goto">  Go to Homepage </button>
                            <h6>Your profile will be verified within the next 3-7 working days</h6>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default StepFour